// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
import * as Sentry from '@sentry/nextjs';

function bakedCheck(str: string | undefined) {
  if (str == null) return str;
  if (str.startsWith('BAKED_')) return undefined;
  return str;
}

// eslint-disable-next-line no-restricted-properties
const SENTRY_ENVIRONMENT = bakedCheck(process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT);
// eslint-disable-next-line no-restricted-properties
const SENTRY_DSN = bakedCheck(process.env.NEXT_PUBLIC_SENTRY_DSN);
// eslint-disable-next-line no-restricted-properties
const RELEASE_VERSION = bakedCheck(process.env.NEXT_PUBLIC_APP_VERSION);

if (SENTRY_ENVIRONMENT == null) {
  console.error('sentry.server failed to init, process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT is null');
} else if (SENTRY_DSN == null) {
  console.error('sentry.server failed to init, process.env.NEXT_PUBLIC_SENTRY_DSN is null');
} else if (RELEASE_VERSION == null) {
  console.error('sentry.server failed to init, process.env.NEXT_PUBLIC_APP_VERSION is null');
} else {
  console.log(`🟢 ☁️ 💂‍♂️`);
  const integrations = [
    Sentry.httpClientIntegration({
      // This array can contain tuples of `[begin, end]` (both inclusive),
      // single status codes, or a combination of both.
      // default: [[500, 599]]
      failedRequestStatusCodes: [[500, 599]],

      // This array can contain Regexes, strings, or a combination of both.
      // default: [/.*/]
      failedRequestTargets: [/.*/],
    }),
  ];
  // only enable replay in production
  // if (SENTRY_ENVIRONMENT == 'prop') {
  //   integrations.push(new Sentry.Replay());
  // }

  Sentry.init({
    debug: false,
    
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    release: RELEASE_VERSION,

    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 0.1,
    // ...
    // Note: if you want to override the automatic release value, do not set a
    // `release` value here - use the environment variable `SENTRY_RELEASE`, so
    // that it will also get attached to your source maps

    integrations,
    // Capture Replay for 0% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
  });
}

// This export will instrument router navigations, and is only relevant if you enable tracing.
// `captureRouterTransitionStart` is available from SDK version 9.12.0 onwards
 
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;